@import "@/ui/variables.css";

.itemDescriptionRendererRoot {
  span {
    font-weight: bold;
  }

  span[data-keyword="other"] {
    color: var(--earthworm);
  }
  span[data-keyword="dmg"] {
    color: var(--red);
  }
  span[data-keyword="heal"] {
    color: var(--green);
  }
  span[data-keyword="buff"] {
    color: var(--blue);
  }
  span[data-keyword="debuff"] {
    color: var(--yellow);
  }
  span[data-keyword="cc"] {
    color: var(--oasis);
  }
}
